import { Controller } from "@hotwired/stimulus"

// Simple toggle controller for showing/hiding content
// Usage:
//   <div data-controller="toggle">
//     <button data-action="click->toggle#toggle">Toggle</button>
//     <div data-toggle-target="content" style="display: none;">Hidden content</div>
//   </div>
export default class extends Controller {
  static targets = ["content", "button"]

  toggle() {
    this.contentTargets.forEach(content => {
      content.style.display = content.style.display === "none" ? "block" : "none"
    })
    
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = this.buttonTarget.style.display === "none" ? "inline-block" : "none"
    }
  }

  show() {
    this.contentTargets.forEach(content => {
      content.style.display = "block"
    })
    
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = "none"
    }
  }

  hide() {
    this.contentTargets.forEach(content => {
      content.style.display = "none"
    })
    
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = "inline-block"
    }
  }
}
